<div [ngClass]="{'loader-overlay': overlay}" *ngIf="loading">
    <div class="loader"></div>
</div>